import Header from './components/Header';
import Hero from './components/Hero';
import SpeedReport from './components/SpeedReport';
import TimelineBand from './components/TimelineBand';
import LongGossip from './components/LongGossip';
import OldReview from './components/OldReview';
import PersonFiles from './components/PersonFiles';
import DownloadBar from './components/DownloadBar';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <SpeedReport />
        <TimelineBand />
        <LongGossip />
        <OldReview />
        <PersonFiles />
        <DownloadBar />
      </main>
      <Footer />
    </div>
  );
}